"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataState = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const FunnelPageHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/state/data/FunnelPageHighchartsOptionsProvider");
const FunnelPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/FunnelPopover");
const FunnelExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/state/data/highcharts/FunnelExportHighchartsButton");
const FunnelChartSettingsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/state/data/highcharts/settings/FunnelChartSettingsComponent");
const FunnelHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/state/data/highcharts/FunnelHighchartsComponent");
const FunnelFormComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/state/data/form/FunnelFormComponent");
const react_router_dom_1 = require("react-router-dom");
const FunnelPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/FunnelPageDataProvider");
const FunnelPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/FunnelPageModelProvider");
const EventsDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsDataProvider");
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = require("src/hello_assets/src/constants");
const Analytics_1 = require("src/hello_assets/src/util/analytics/Analytics");
const DataState = () => {
    const eventsDataContext = (0, EventsDataProvider_1.useEventsDataContext)();
    (0, react_1.useEffect)(() => {
        Analytics_1.Analytics.trackViewFunnel();
    }, []);
    (0, react_1.useEffect)(() => {
        eventsDataContext.fetchEventNames();
    }, []);
    const loaded = eventsDataContext.eventNamesState.loaded;
    const isEmpty = lodash_1.default.isEmpty(eventsDataContext.eventNamesState.data);
    const noEventsFunnelStub = (loaded && isEmpty) ? React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Result, { className: "ug-result-noIcon", status: "error", icon: React.createElement(React.Fragment, null), subTitle: React.createElement(React.Fragment, null,
                    "To build a funnel events need to be tracked.",
                    React.createElement("br", null),
                    "You don\u2019t have any events yet.",
                    React.createElement("br", null),
                    "Please integrate the ",
                    React.createElement("a", { href: constants_1.URL_GITHUB, target: "_blank" }, "latest version of an SDK"),
                    " and follow the instructions",
                    React.createElement("br", null),
                    "to track up to 10 most important actions users can do in your dapp.") }))) : null;
    return React.createElement(React.Fragment, null,
        React.createElement(FunnelPageHighchartsOptionsProvider_1.FunnelPageHighchartsOptionsProvider, null,
            React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
                    React.createElement(React.Fragment, null, "Funnel"),
                    React.createElement(FunnelPopover_1.FunnelPopover, null)), extra: React.createElement(antd_1.Space, null,
                    React.createElement(FunnelExportHighchartsButton_1.FunnelExportHighchartsButton, null)) }),
            React.createElement(PageContent_1.default, null,
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(FunnelChartSettingsComponent_1.FunnelChartSettingsComponent, null),
                    React.createElement(FunnelHighchartsComponent_1.FunnelHighchartsComponent, null)),
                noEventsFunnelStub,
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(antd_1.Row, null,
                        React.createElement(antd_1.Col, { span: 24 },
                            React.createElement(FunnelFormComponent_1.FunnelFormComponent, null)))))),
        process.env.NODE_ENV === "development" ? React.createElement(DebugView, null) : null);
};
exports.DataState = DataState;
const DebugView = () => {
    const pageDataContext = (0, FunnelPageDataProvider_1.useFunnelPageDataContext)();
    const pageModelContext = (0, FunnelPageModelProvider_1.useFunnelPageModelContext)();
    const location = (0, react_router_dom_1.useLocation)();
    return React.createElement(PageContent_1.default, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Row, { gutter: [16, 16] },
                React.createElement(antd_1.Col, { span: 24 },
                    "location:",
                    React.createElement("br", null),
                    React.createElement("span", { style: { fontSize: "10px", maxHeight: 180, wordBreak: "break-all" } }, decodeURI(location.search))),
                React.createElement(antd_1.Col, { span: 8 },
                    "pageModelFormState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageModelContext.pageModelFormState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataURLState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.urlState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.state, null, 4))))));
};
